import { render, staticRenderFns } from "./TablePageAttrEntity.vue?vue&type=template&id=32f7e8ed"
import script from "./TablePageAttrEntity.vue?vue&type=script&lang=js"
export * from "./TablePageAttrEntity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports